import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import UserRequests from "../../../components/userrequests/userrequests";

export default function UserProfileRequests() {
  return (
    <UserProfileLayout>
      <div className="w-full bg-white rounded-2xl border border-primary50 gap-4 flex p-8">
        <UserRequests />
      </div>
    </UserProfileLayout>
  );
}
